import upperFirst from 'lodash/upperFirst'
import { compose, lifecycle, setDisplayName } from 'recompose'
import withStatus from 'hocs/bases/withStatus'
import withSnackBar from 'store/snackbar/withSnackBar'

const withUpdateResource = ({
  resourceName = 'resource',
  getAction = () => Promise.resolve,
  getSuccessMessage,
  getFailureMessage,
  getOnActionSuccess,
  getOnSuccess,
}) => {
  const ResourceName = upperFirst(resourceName)
  return compose(
    setDisplayName(`With Update ${ResourceName}`),
    withSnackBar,
    withStatus({
      actionName: `update${ResourceName}`,
      statusName: `update${ResourceName}Status`,
      getAction,
      getOnRequest: (props) => () => props.showMessage({ message: null }),
      getSuccessMessage: getSuccessMessage || (() => `${ResourceName} has been updated.`),
      getFailureMessage: getFailureMessage || (() => `Cannot update ${ResourceName}.`),
      getOnActionSuccess,
      getOnSuccess,
    }),
    lifecycle({
      componentWillReceiveProps(nextProps, nextContext) {
        const { [`update${ResourceName}Status`]: nextUpdateStatus } = nextProps
        const { [`update${ResourceName}Status`]: updateStatus } = this.props
        if (
          updateStatus.isRequest &&
          (
            nextUpdateStatus.isSuccess ||
            nextUpdateStatus.isFailure
          )
        ) {
          this.props.showMessage({ message: nextUpdateStatus.message })
        }
      },
    }),
  )
}

export default withUpdateResource



// WEBPACK FOOTER //
// ./src/hocs/bases/withUpdateResource.js